"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBackupImgHost = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _gtools = require("@gaodun.com/gtools");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var getBackupImgHost = function getBackupImgHost() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, data;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("https://".concat(_gtools.environment.getApiEnv(), "apigateway.gaodun.com/luffy/internal/api/v1/config/penetrateList?businessKey=IMAGE_DOMAIN&businessType=SCRM"));
          case 3:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 12;
              break;
            }
            _context.next = 7;
            return response.json();
          case 7:
            data = _context.sent;
            if (!window.gd) {
              window.gd = {}; // 如果不存在，初始化它
            }
            if (data.status === 0) {
              window.gd.imgDomainList = data.result; // 存储到 window.gd
            }
            _context.next = 13;
            break;
          case 12:
            console.error('获取备用域名失败');
          case 13:
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            console.error('请求失败:', _context.t0);
          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));
};
exports.getBackupImgHost = getBackupImgHost;